import { Box, FormControl, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { AffiliateNetworkConfig, EverflowConfig, MerchantAffiliateNetwork } from "src/types/merchants"
import { encryptWithPubkey } from "src/utils/rsa"

interface EverflowInputFormProps {
  handleAffiliateNetworkConfigChange: (newConfig: AffiliateNetworkConfig) => void
  existingConfig: AffiliateNetworkConfig
}

const EverflowInputForm: React.FC<EverflowInputFormProps> = ({handleAffiliateNetworkConfigChange, existingConfig}) => {
  const [apiKey, setApiKey] = useState('')
  const [encryptedApiKey, setEncryptedApiKey] = useState('')
  const [offerId, setOfferId] = useState(existingConfig.everflow?.offerId)

  // encrypt the api key as the user makes changes to it
  useEffect(() => {
    if (!apiKey) {
      setEncryptedApiKey('')// no need to encrypt an empty string
    }  else {
      setEncryptedApiKey(encryptWithPubkey(apiKey))
    }
  },[apiKey])

  // set the new state in the merchant object
  useEffect(() => {
    const newConfig = {
      type: MerchantAffiliateNetwork.EVERFLOW,
      everflow: {
        networkApiKey: {
          transportEncrypted: encryptedApiKey,
        },
        offerId: offerId,
      } as EverflowConfig
    }

    handleAffiliateNetworkConfigChange(newConfig)
  },[encryptedApiKey, offerId, handleAffiliateNetworkConfigChange])

  return (
    <Box>
      <FormControl className="formControlsContainer">
        <TextField
          value={apiKey}
          onChange={(e) => {
            setApiKey(e.target.value)
          }}
          label='Everflow Network API Key'
          variant="outlined"
        />
      </FormControl>
      <FormControl className="formControlsContainer">
          <TextField
            value={offerId}
            onChange={(e) => {
              setOfferId(e.target.value)
            }}
            label='Everflow Offer ID'
            variant="outlined"
          />
        </FormControl>
    </Box>
  )
}

export default EverflowInputForm
